__turbopack_context__.v({
  "accordionSlideOverwrite": "form-module-scss-module__NNEv-q__accordionSlideOverwrite",
  "fadeIn": "form-module-scss-module__NNEv-q__fadeIn",
  "fadeOut": "form-module-scss-module__NNEv-q__fadeOut",
  "formDescription": "form-module-scss-module__NNEv-q__formDescription",
  "formItem": "form-module-scss-module__NNEv-q__formItem",
  "formLabelError": "form-module-scss-module__NNEv-q__formLabelError",
  "formMessage": "form-module-scss-module__NNEv-q__formMessage",
  "scaleIn": "form-module-scss-module__NNEv-q__scaleIn",
  "scaleOut": "form-module-scss-module__NNEv-q__scaleOut",
  "zoomIn": "form-module-scss-module__NNEv-q__zoomIn",
  "zoomOut": "form-module-scss-module__NNEv-q__zoomOut",
});
